import * as React from 'react';

import { StageLayout } from '../../components/StageLayout';
import { PaymentContainer } from '../PaymentContainer';

export const PaymentPageContainer: React.FC = () => {
  return (
    <StageLayout>
      <PaymentContainer />
    </StageLayout>
  );
};

PaymentPageContainer.displayName = 'PaymentPageContainer';
